'use client';

import {Error505} from '@web-landing/components/Error505/Error505';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function GlobalError({error}: {error: any}) {
  return (
    <html>
      <body>
        <Error505 error={error} />
      </body>
    </html>
  );
}
